export default "__VITE_ASSET__BzXzBdXM__"